import { Paragraph, YStack } from 'tamagui';

import { Text } from '@/components/text';

// Decision 4 (issue #563): the short explainer card that renders below
// a sparse list (fewer than 3 matches / 5 threads) so the dead space
// under two cards says something instead of nothing. Warm, plain, a
// little wry (brand voice, decision 43) -- two sentences, no sales
// pitch, and the empty state still owns the zero case. A borderless text
// block, not a card: it groups nothing, so it sits on the gutter like the
// rest of the page.
export function ListExplainer({ title, body }: { title: string; body: string }) {
  return (
    <YStack gap="$2">
      <Text color="$color" fontWeight="$semibold" textAlign="left">
        {title}
      </Text>
      <Paragraph color="$colorSecondary" fontSize="$meta" lineHeight="$meta" textAlign="left">
        {body}
      </Paragraph>
    </YStack>
  );
}
